import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { ReversedGradientBorder } from '../commons'

import * as styles from './index.module.css'

const OS2LongRangeLidar = ({ title, images, mobileOnlyImages, subtitle }) => {
  const isMobile = typeof window !== `undefined` && window.innerWidth <= 1024
  let image = images[0]
  if (isMobile && mobileOnlyImages) {
    image = mobileOnlyImages[0]
  }
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <ReversedGradientBorder
          className={styles.gradBorder}
          height="1px"
        ></ReversedGradientBorder>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.description}>{subtitle.subtitle}</div>
        <div className={styles.imageContainer}>
          <GatsbyImage
            image={image.iphero}
            style={{ height: '100%', width: '100%' }}
            alt={image?.description}
          />
        </div>
      </div>
    </div>
  )
}

export default OS2LongRangeLidar
